
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { PageHeader } from "../Components/Text.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextButton } from "../Components/Button.js";
import { RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function View(viewInputProps) {
    let elems_5, elems, elems_1, children, elems_2, children_2, children_4, elems_4, value_34;
    const _arg = viewInputProps._arg1;
    const t = useTranslation()[0];
    const phoneNumber = t("global.phone_number");
    return reactElement("div", createObj(ofArray([["id", "support-container"], ["className", ""], (elems_5 = [createElement(PageHeader, {
        Text: "Support",
    }), reactElement("h2", createObj(singleton((elems = [t("general.contact")], ["children", reactApi.Children.toArray(Array.from(elems))])))), reactElement("div", createObj(ofArray([["className", "mb-4"], (elems_1 = [t("support.description")], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (children = ofArray([reactElement("span", createObj(ofArray([["className", "category mr-1"], (elems_2 = [t("support.phone")], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("a", {
        href: concat("tel:", ...phoneNumber),
        children: phoneNumber,
    })]), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), (children_2 = ofArray([reactElement("span", {
        className: "category mr-1",
        children: "E-Mail:",
    }), reactElement("a", {
        href: "mailto:support@inventory-one.com",
        children: "support@inventory-one.com",
    })]), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children_2)),
    })), (children_4 = ofArray([reactElement("span", {
        className: "category mr-1",
        children: "Homepage:",
    }), createElement(TextButton, {
        ComponentState: "enabled",
        Label: "www.inventory-one.com",
        OnClick: () => {
            RouterModule_nav(singleton("https://www.inventory-one.com"), 1, 1);
        },
        TestId: "support-inventoryone-button",
        Variant: "default",
    })]), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children_4)),
    })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_4 = [reactElement("h2", {
        children: reactApi.Children.toArray(["Feedback"]),
    }), reactElement("p", createObj(ofArray([["className", join(" ", ["mb-4"])], (value_34 = "Dein Feedback ist uns wichtig! Über den folgenden Link erreichst du das Feedback-Formular, damit wir uns stetig verbessern können.", ["children", value_34])]))), createElement(TextButton, {
        ComponentState: "enabled",
        Label: "Feedback-Formular",
        OnClick: () => {
            RouterModule_nav(singleton("https://forms.office.com/e/en5R0qHt68"), 1, 1);
        },
        TestId: "support-feedback-formular-button",
        Variant: "default",
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

